var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Can',{attrs:{"I":"view","a":"sensors_journal"}},[_c('TableRoute',{attrs:{"title":'Задачи диагностики',"apiStore":_vm.apiStore,"headers":_vm.headers,"dense":true,"itemPageRouteName":"DiagTask","nameJournal":"sensors_journal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }